<template>
    <!--解决弹窗-->
    <el-dialog 
      title="解决" 
      :visible.sync="dialogVisibleSolve" 
      width="90%" 
      :before-close="handleCloseSolve" 
      :close-on-press-escape="false" 
      :close-on-click-modal="false">
      <el-form 
        :model="solve" 
        ref="solve" 
        :inline="true">
        <el-form-item class="solve_summernote_item" prop="content" style="width: 100%;">
          <van-field
            style="border:0 solid #F5F5F5;border-width:3px 0 0 0;font-size:115%;"
            type="textarea"
            maxlength="999"
            show-word-limit
            rows="2"
            autosize 
            v-model="solve.content"
            placeholder="添加回复" />

          <div style="padding:10px;border:0 solid #F5F5F5;border-width:0 0 5px 0;">
            <MobileTicketUpload ref="up5"/>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseSolve">取消</el-button>
        <SubmitTicketButton @click="solveOrder" buttonText="提交" ref="solveBtn_1"/>
      </span>
    </el-dialog>
</template>

<script>
export default {
  name: "MobileTicketSolveDialog",

  props : ["ticketNo"],

  data() {
    return {
      dialogVisibleSolve: false,
      solve: {
        content: '',
        orderNoticeList: [] //通知列表
      },
    };
  },

  methods: {
    show() {
        this.dialogVisibleSolve = true;
    },

    //解决
    solveOrder() {
      var _this = this;

      this.$refs.solve.validate(valid => {
        if ( !valid ) {
          return false
        }

        _this.$refs.solveBtn_1.disable();

        var data = {
          'orderId': _this.ticketNo,
          'orderRemark.remarkContent': _this.solve.content
        }

        data.attachmentList = _this.$refs.up5.getAttachmentList();

        _this.$http.post('/ticket/v2-workOrder/solve', data).then(response => {
          _this.$refs.solveBtn_1.enable();

          var result = response.data;
          if(result.status) {
            _message('解决工单成功');

            _this.handleCloseSolve();
            _this.$refs.up5.setAttachmentList([]);

            _this.$emit('change', null);
          } else {
            if ( !!result.message ) {
              _this.$alert(result.message);
            } else {
              _this.$alert("工单系统后台错误 #789");
            }
          }
        }, response => {
          _this.$refs.solveBtn_1.enable();

          _this.$alert('网络繁忙，请稍后重试 #793')
        });
      })
    },

    //弹出层关闭-解决
    handleCloseSolve() {
      this.$refs['solve'].resetFields();
      this.dialogVisibleSolve = false;
    }
  }
};
</script>

<style>
  .solve_summernote_item .note-editor.note-frame {
    width: 100%;
  }
  .el-form-item__content {
    width: 100%;
  }

  .solve_summernote_item {
    padding-bottom: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketSolveDialog.vue